<template>
<div class="leftover-mealtime-slot" v-if="this.dailySummary && this.dailySummary.day">
  <div
    class="heading"
    @click.stop="
      () => {
        $emit('showLeftoverOptions', appliedMealtime);
      }
    "
  >
    <div class="title">{{ $t('lblLeftovers') }}</div>
    <div class="option-count">
      <h4>{{ (this.dailySummary.day[appliedMealtime].leftoverOptions || []).length }} {{ $t('lblAvailable') }}</h4>
      <BaseIcon class="date-selec-icon" name="chevron-right" />
    </div>
  </div>
  <div class="planned-leftovers" v-if="(this.dailySummary.day[appliedMealtime].leftovers || []).length">
    <hr />
    <div
      v-for="(leftover, i) in this.dailySummary.day[appliedMealtime].leftovers"
      :key="i"
      class="leftover"
      @click.stop="
        () => {
          const usedLeftoverOption = dailySummary.day[appliedMealtime].leftoverOptions.find((option) => option.recipeId === leftover.id);
          leftover.preparationDate = usedLeftoverOption.preparationDate;
          $emit('showLeftoverDetails', leftover);
        }
      "
    >
      <div>
        <div class="recipe-chip" :style="`backgroundImage: url(${leftover.imageUrl || leftover.imageURL});}`"> </div>
      </div>
      <div>
        <div class="recipe-title">
          {{ leftover.title }}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { planComputed } from '@state/helpers';

export default {
  props: {
    isEmbed: {
      type: Boolean,
    },
    appliedMealtime: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...planComputed,
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.leftover-mealtime-slot {
  background-color: $color-leftover-mealtime-slot-bg;
  border: 1px solid $base-border-color;
  border-radius: $base-border-radius;
  margin-bottom: 0.8rem;
  padding: 1.7rem;

  &:hover {
    cursor: pointer;
  }

  .heading {
    display: flex;
    justify-content: space-between;

    .title {
      font-size: 1.5rem;
      font-weight: normal;
      margin: auto 0;
    }

    .option-count {
      display: flex;
      justify-content: flex-end;

      h4 {
        color: $color-leftovers-available;
        font-size: 1.5rem;
        font-weight: normal;
        line-height: 1.5rem;
        margin: 0 2rem 0 0;
      }

      svg {
        color: $color-lightGrey;
        font-size: 1.5rem;
      }
    }
  }

  .planned-leftovers {
    cursor: pointer;

    .leftover {
      align-items: center;
      display: flex;

      .recipe-chip {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border: 2px solid $color-meal-widget-item-border;
        border-radius: $border-radius-circle;
        box-shadow: $color-meal-widget-item-shadow;
        color: $color-meal-widget-item-text;
        font-weight: bold;
        height: 5rem;
        width: 5rem;
      }

      .recipe-title {
        font-size: 1.5rem;
        font-weight: normal;
        line-height: 1.1;
        padding-left: 1rem;
      }
    }
  }
}
</style>
